/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Home, ArrowBackIos, AccountCircle, ExitToApp, CropFree } from "@mui/icons-material"; // ExitToApp for logout
import CalculateIcon from '@mui/icons-material/Calculate';
// import { useDarkMode } from '../components/DarkModeContext';
import AccessAlarmsIcon from '@mui/icons-material/AccessAlarms';
import colors from "../colour";
import eCosiconD from "../icon/eCos-icon2.png";
import MenuIcon from '@mui/icons-material/Menu';
import { UseAccessLevel } from "../AccessLevelContext";
import { getUserDetails } from "../api/user";
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import SimCardIcon from '@mui/icons-material/SimCard';
import TroubleshootIcon from '@mui/icons-material/Troubleshoot';

const Sidebar = ({ isOpen, open, onClose }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [userData, setuserData] = useState({});
  // const [siteId, setSiteId] = useState(null);
  const { accessLevel } = UseAccessLevel();
  const [menuItems, setMenuItems] = useState([
    { title: "Plant List", src: <Home style={{ fontSize: isOpen ? "1.4vw" : "1.3vw" }} />, path: "/PlantList", gap: false },
    { title: "User Info", src: <AccountCircle style={{ fontSize: isOpen ? "1.4vw" : "1.3vw" }} />, path: "/user-info", gap: false },
    { title: "Big Screen", src: <CropFree style={{ fontSize: isOpen ? "1.4vw" : "1.3vw" }} />, path: "/Map", gap: false },
  ]);


  const [selectedIndex, setSelectedIndex] = React.useState(null);
  // const { darkMode, toggleDarkMode } = useDarkMode();

  // Highlight the correct menu item based on the current route
  useEffect(() => {
    const currentIndex = menuItems.findIndex((menu) => menu.path === location.pathname);
    setSelectedIndex(currentIndex);
  }, [location.pathname, menuItems]);

  // useEffect(() => {
  //   if (location?.state?.siteId) {
  //     setSiteId(location?.state?.siteId);
  //   }
  // }, [location?.state?.siteId]);

  // Fetch user data and update menu items
  useEffect(() => {
    const fetchData = async () => {
      try {
        const userInfoResp = await getUserDetails();
        setuserData(userInfoResp);

        setMenuItems((prevMenus) => {
          let newMenus = [...prevMenus];

          // Add access-level-3-only items
          if (accessLevel === 3) {
            const hasLicensesUpdate = newMenus.some(menu => menu.path === "/LicensesUpdate");
            if (!hasLicensesUpdate) {
              newMenus = [
                ...newMenus,
                {
                  title: "Licenses Update",
                  src: <AccessAlarmsIcon style={{ fontSize: isOpen ? "1.4vw" : "1.3vw" }} />,
                  path: "/LicensesUpdate",
                  gap: false
                },
                {
                  title: "SIMManagementPage",
                  src: <SimCardIcon style={{ fontSize: isOpen ? "1.4vw" : "1.3vw" }} />,
                  path: "/SIMManagementPage",
                  gap: false
                },
                {
                  title: "AnalyticsDashboard",
                  src: <TroubleshootIcon style={{ fontSize: isOpen ? "1.4vw" : "1.3vw" }} />,
                  path: "/AnalyticsDashboard",
                  gap: false
                },
              ];
            }
          }

          // Add Dynamic Diagram if accessLevel === 3 OR is_sld === true
          const hasDynamicDiagram = newMenus.some(menu => menu.path === "/DynamicDiagram");
          if (!hasDynamicDiagram && (accessLevel === 3 || userInfoResp?.is_sld === true)) {
            newMenus.splice(3, 0, {
              title: "Dynamic Diagram",
              src: <AccountTreeIcon style={{ fontSize: isOpen ? "1.4vw" : "1.3vw" }} />,
              path: "/DynamicDiagram",
              gap: false
            });
          }

          return newMenus;
        });

      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    };

    fetchData();
  }, [accessLevel]);

  const handleMenuClick = (index, path) => {
    setSelectedIndex(index);
    navigate(path);
  };

  // Handle Logout and clear data
  const handleLogout = () => {
    localStorage.clear();
    sessionStorage.clear();
    navigate("/");
  };


  return (
    <div
      className="h-full p-0.5 md:p-2 border-r relative"
      style={{
        backgroundColor: colors.l8,
        width: "100%",
        height: "100%",
        transition: "all 0.3s ease",
        borderRight: `0.15vw solid ${colors.l3}`,
        paddingTop: "3vh",
      }}
    >


      <div className="flex flex-col h-full"> {/* Flex container */}
        {/* Arrow Icon to toggle the sidebar */}
        <div
          className={`absolute cursor-pointer top-9 rounded-full flex justify-center items-center ${isOpen ? "" : "hidden"}`}
          style={{
            width: "1.5vw",
            height: "1.5vw",
            backgroundColor: colors.l1,
            border: "2px solid",
            borderColor: colors.l3,
            right: isOpen ? "-0.9vw" : "-0.8vw",
          }}
          onClick={isOpen ? onClose : open}
        >
          {isOpen && (
            <ArrowBackIos style={{ fontSize: "0.8vw", color: colors.d1 }}
            />
          )}
        </div>

        {/* Sidebar Logo Image */}
        <div className={`flex flex-col items-center justify-center gap-x-2 ${isOpen ? "h-[8vh]" : "h-[5vh]"}`}>
          {!isOpen && (
            <MenuIcon
              src={eCosiconD}
              sx={{ fontSize: isOpen ? "1.4vw" : "1.3vw", color: colors.f2 }}
              alt="eCos Icon"
              onClick={isOpen ? onClose : open}
            />
          )}

          {isOpen && (
            <img
              className="h-[9vh] w-auto object-contain p-[0.5vw] shadow-sm"
              src={
                userData?.logo
                  ? `data:image/jpeg;base64,${userData.logo}`
                  : eCosiconD
              }
              alt="eCos logo"
            />

          )}


        </div>


        {/* Sidebar Menu */}
        <div className="flex-grow"> {/* Menu content */}
          <ul className={`pt-0 md:pt-6`}>
            {menuItems.map((menu, index) => (
              <li
                key={index}
                className={`flex justify-center items-center rounded-md p-[1vh] cursor-pointer hover:bg-purple-300 gap-x-4 ${menu.gap ? "mt-9" : "mt-3"} ${index === selectedIndex ? "bg-purple-500" : ""}`}
                onClick={() => handleMenuClick(index, menu.path)}
                sx={{ padding: { xs: 0, md: '1vh', }, }}
                style={{ color: index === selectedIndex ? 'white' : (colors.f2) }}
              >
                <span className={`${index === selectedIndex ? "text-white" : ""}`}>
                  {menu.src}
                </span>
                <span className={`${!isOpen && "hidden"} origin-left`} style={{ fontSize: "0.8vw" }}>
                  {menu.title}
                </span>
              </li>
            ))}
          </ul>
        </div>

        {/* Dark Mode Toggle and Logout Button at the bottom */}
        {/* <div className="mb-[2.5vh] flex justify-center items-center cursor-pointer gap-x-4">
          <MaterialUISwitch checked={darkMode} onChange={toggleDarkMode} />
          <span className={`${!isOpen && "hidden"} origin-left`} style={{ fontSize: "0.8vw", color: darkMode ? colors.f2 : colors.f2 }}>
            Theme Switching
          </span>
        </div> */}


        {/* Logout Button */}
        <div
          className="flex justify-center items-center cursor-pointer gap-x-4"
          style={{ fontSize: "0.8vw", color: colors.f2 }}
          onClick={handleLogout}
        >
          <span>
            <ExitToApp style={{ fontSize: isOpen ? "1.4vw" : "1.3vw" }} />
          </span>
          <span className={`${!isOpen && "hidden"} origin-left`}>
            Logout
          </span>
        </div>
      </div>
    </div>
  );
};

export default Sidebar;
